module.exports = __webpack_public_path__ + "img/qr-gzh.ca24d120.jpg";